import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";

class PVISeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForPVI = this.yAccessorForPVI.bind(this);
    this.yAccessorForMA = this.yAccessorForMA.bind(this);
  }
  yAccessorForPVI(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).pvi;
  }
  yAccessorForMA(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).pviMA;
  }
  render() {
    const { className, onDoubleClick, onContextMenu } = this.props;

    const { strokePVI, strokeMA } = this.props;

    const { clip } = this.props;

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorForPVI}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokePVI}
          clip={clip}
        />
        <LineSeries
          yAccessor={this.yAccessorForMA}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeMA}
          clip={clip}
        />
      </g>
    );
  }
}

PVISeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  clip: PropTypes.bool.isRequired,
  strokePVI: PropTypes.object.isRequired,
  strokeMA: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

PVISeries.defaultProps = {
  className: "react-stockcharts-pvi-series",
  clip: true,
};

export default PVISeries;
